<template>


<div class="row" v-if="studentDetails != null && Object.keys(studentDetails).length > 0">
<div class="card w-100">
    <div class="card-body px-3 py-0">

    <div class="row">
	 <div class="col-sm-12 col-md-4 p-4">
	    <p class="mb-1"><span class="label"><b>Student Name:</b> </span> <span class="label"><a :href="'mailto:' + studentDetails.email" title="Email">{{ student_full_name }}</a> {{ (studentDetails.stu_pname.length > 0) ? `(${studentDetails.stu_pname})` : '' }}</span></p>
            <p class="mb-1"><span class="label"><b>Personal Pronouns:</b> </span> <span class="label">{{ `${studentDetails.pronouns}` }} </span></p>
            <p class="mb-1"><span class="label"><b>Primary Advisor:</b> </span> <span v-if="studentDetails.person && typeof studentDetails.person.uin !== 'undefined'" class="label"><a :href="'https://apps.uis.edu/directory/person/' + studentDetails.person.uin" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Advisor Info">{{(studentDetails.person.firstName == null) ? '' : `${studentDetails.person.firstName} ${studentDetails.person.lastName}`}}</a></span></p>
			<p v-if="typeof studentDetails.faculty_advisor.uin !== 'undefined'" class="mb-1"><span class="label"><b>Faculty Advisor:</b> </span> <span v-if="studentDetails.faculty_advisor && typeof studentDetails.faculty_advisor.uin !== 'undefined'" class="label"><a :href="'https://apps.uis.edu/directory/person/' + studentDetails.faculty_advisor.uin" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Advisor Info">{{(studentDetails.faculty_advisor.firstName == null) ? '' : `${studentDetails.faculty_advisor.firstName} ${studentDetails.faculty_advisor.lastName}`}}</a></span></p>
            <p class="mb-1"><span class="label"><b>Permanent State:</b> </span> <span class="label">{{ `${studentDetails.permanent_state}` }} </span></p>
            <p class="mb-1"><span class="label"><b>Major1:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.major1 !== "undefined") ? `${studentDetails.studentRecord.major1.description}` : '' }} <v-btn icon class="mx-0" href="https://www.uis.edu/registration/forms/" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Major Info"><v-icon>account_balance</v-icon></v-btn></span></p>
            <p v-if='typeof studentDetails.studentRecord.major2 !== "undefined"' class="mb-1"><span class="label"><b>Major2:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.major2 !== "undefined") ? `${studentDetails.studentRecord.major2.description}` : '' }}</span></p>
            <p class="mb-1"><span class="label"><b>Minor1:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.minor1 !== "undefined") ? `${studentDetails.studentRecord.minor1.description}` : '' }}</span></p>
            <p v-if='typeof studentDetails.studentRecord.minor2 !== "undefined"' class="mb-1"><span class="label"><b>Minor2:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.minor2 !== "undefined") ? `${studentDetails.studentRecord.minor2.description}` : '' }}</span></p>
	    <p class="mb-1"><span class="label"><b>Program1:</b> </span> <span :title="(is_licensure_issue) ? 'Out of state licensure student' : ''" class="label" :style="(is_licensure_issue) ? 'background-color:orange' : 'background-color:white'"> {{ (typeof studentDetails.studentRecord.program1 !== "undefined") ? `${studentDetails.studentRecord.program1.description}` : '' }}</span></p>
            <p class="mb-1"><span class="label"><b>Admit Type:</b> </span> <span class="label">{{ `${studentDetails.admit_type}` }} </span></p>
            <p class="mb-1"><span class="label"><b>Student Type:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.studentType !== "undefined") ? `${studentDetails.studentRecord.studentType.description}` : '' }}</span></p>
            <p class="mb-1"><span class="label"><b>Application Term:</b> </span> <span class="label">{{ `${studentDetails.application_term}` }} </span></p>
            <p class="mb-1"><span class="label"><b>Admit Status:</b> </span> <span class="label">{{ `${studentDetails.most_recent_decision}` }} </span></p>
	    <p class="mb-1"><span class="label"><b>Confidentiality Indicator:</b> </span> <span class="label">{{ (studentDetails.confidentiality_ind == true) ? 'Yes':'No'  }} </span></p>
        <!--<p class="mb-1"><span class="label"><b>Title IX Training Status:</b> </span> <span class="label" :style="(studentDetails.title9_training_status === 'completed' || studentDetails.title9_training_status === 'course_complete') ? 'background-color:green' : (studentDetails.title9_training_status === 'not_started' || studentDetails.title9_training_status === 'in_progress' || studentDetails.title9_training_status === 't9_hold_from_previous_semester') ? 'background-color:orange' : 'background-color:white'">{{ studentDetails.title9_training_status }} </span></p> -->
	    <p v-if="studentDetails.orientation_type != null" class="mb-1"><span class="label"><b>Orientation Info:</b> </span> <span class="label">{{ (typeof studentDetails.orientation_start_dt !== "undefined") ? `${studentDetails.orientation_start_dt} (${studentDetails.attended_orientation})` : '' }}</span></p>
        </div>
	 <div class="col-sm-12 col-md-4 p-4">
          <p class="mb-1"><span class="label"><b>Level:</b> </span> <span class="label">{{ (typeof studentDetails.studentRecord.level1 !== "undefined") ? `${studentDetails.studentRecord.level1.description}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Classification:</b> </span> <span class="label">{{ (typeof studentDetails.studentClass !== "undefined") ? `${studentDetails.studentClass.description}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Total Credits:</b> </span> <span class="label">{{ `${studentDetails.total_credits}` }} </span></p>
          <p class="mb-1"><span class="label"><b>Transfer Credits:</b> </span> <span class="label">{{ `${studentDetails.xfer_credits}` }} </span></p>
          <p v-if="isAdmin === true" class="mb-1"><span class="label"><b>Cumulative Prior Institution GPA:</b> </span> <span class="label">{{ (typeof studentDetails.gpaugrad != null) ? `${studentDetails.gpaugrad}` : 'null'  }}</span></p>
          <p v-if="isAdmin === true" class="mb-1"><span class="label"><b>HS GPA:</b> </span> <span class="label">{{ (typeof studentDetails.gpas !== "undefined" && studentDetails.gpas.hsGpa != null) ? `${studentDetails.gpas.hsGpa}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Institution GPA:</b> </span> <span class="label">{{ (typeof studentDetails.gpas !== "undefined") ? `${studentDetails.gpas.levelInstitutionalGpa}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Transfer GPA:</b> </span> <span class="label">{{ (typeof studentDetails.gpas !== "undefined") ? `${studentDetails.gpas.levelTransferGpa}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Overall GPA:</b> </span> <span class="label">{{ (typeof studentDetails.gpas !== "undefined") ? `${studentDetails.gpas.levelOverallGpa}` : '' }}</span></p>
          <p class="mb-1"><span class="label"><b>Time Ticket:</b> </span> <span class="label">{{ `${studentDetails.timeticket}` }} </span></p>
          <p class="mb-1"><span class="label"><b>Honors Student:</b> </span> <span class="label">{{ (studentDetails.is_honors_student == true) ? 'Yes':'No'  }} </span></p>
          <p class="mb-1"><span class="label"><b>Math Placement:</b> </span> <span v-if="isAdmin === true" class="label"><a :href="'https://apps.uis.edu/placements/placement/math-explain/' + uinFromStore" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Math Placement Details">{{ `${studentDetails.mathplacement}` }}</a></span><span  v-else class="label">{{ `${studentDetails.mathplacement}` }} </span> <span class="label">(Math Placement Test Taken: </span> <span class="label"><b>{{ `${studentDetails.math_placement_test_taken}` }}</b>)</span></p>
	      <p class="mb-1"><span class="label"><b>English Placement:</b> </span> <span class="label">{{ `${studentDetails.englishplacement}` }} (<span v-html="(studentDetails.needs_english_placement == 'Yes') ? rawHtml : (studentDetails.needs_english_placement == 'No') ? 'Placement test not needed' : studentDetails.needs_english_placement"></span>)</span></p>
	    <p class="mb-1"><span class="label"><b>Academic Standing:</b> </span> <span class="label" :style="((academic_standings.includes(studentDetails.last_acad_std_desc)) ? 'background-color:orange' : 'background-color:white')">{{ `${studentDetails.last_acad_std_desc}` }} </span></p>
	    <p v-if="isAdmin === true" class="mb-1"><span class="label"><b>Last Webmail Logon:</b> </span> <span class="label">{{ (studentDetails.last_logon_time != null) ? `${studentDetails.last_logon_time}` : '' }} </span></p>
	    <p v-if="isAdmin === true" class="mb-1"><span class="label"><b>Attributes:</b> </span> <span class="label">{{ `${studentDetails.attributes}` }}  <v-btn v-if="getSports().sport != 'None'" icon color="blue" class="mx-0" :title="`Athlete - ${getSports().sport}`"><v-icon>{{ `${getSports().icon}` }}</v-icon></v-btn></span></p>
	    <p  v-if="isAdmin === true && studentDetails.housing" class="mb-1"><span class="label"><b>On Campus Housing:</b> </span> <span class="label">{{ `${studentDetails.housing}` }} </span></p>
        </div>
	<div style="text-align: center;" class="col-sm-12 col-md-3 p-4" v-if="isAdmin === true">
  <p><img width="80" :title="uinFromStore" height="100" :src="'data:image/jpeg;base64,' + studentDetails.pic" /></p>
	<div><v-btn icon href="https://www.uis.edu/registration/onlinereg/" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Register Now">Register Now <v-icon>school</v-icon></v-btn></div>
	<div><v-btn icon href="https://bxsprod.apps.uillinois.edu/WX/?DSN=BANPROD_4UIS&sso=true" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Go to BDM">Go to BDM <v-icon>file_copy</v-icon></v-btn></div>
	<div><v-btn icon :href="`https://apps.uis.edu/adviseu/studentcoursesearch/${uinFromStore}`" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Course History">Course History <v-icon>bookmark</v-icon></v-btn></div>

    <p><v-dialog v-model="dialogadd" max-width="500px">
                <template v-slot:activator="{ on }">
		<p><v-btn v-on="on" icon title="Add Contact">Add Contact<v-icon>person_add</v-icon></v-btn></p>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Contact - {{ student_full_name }} [{{ uins_count }}]</span>
			<v-spacer></v-spacer>
			<v-icon @click="closeadd">mdi-close</v-icon>
                    </v-card-title>

                    <div v-if="validationErrors">
                        <ul class="alert alert-danger">
                            <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                        </ul>
                    </div>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex>
				<v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="addedItem.start" label="Contact Date" prepend-icon="date_range" clearable readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="addedItem.start" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                                </v-flex>
                                <v-flex>
                                    <v-select v-model="addedItem.format" :items="request_types" item-text="option" item-value="value" label="Format" outlined></v-select>
                                </v-flex>
                                <v-flex>
                                    <v-textarea v-model="addedItem.advisingdetails" auto-grow label="Notes:" clearable></v-textarea>
                                </v-flex>
                                <v-flex>
                                    <v-text-field v-model="addedItem.time_spent" label="Time Spent (minutes):" clearable></v-text-field>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

	<v-dialog v-model="dialoguins" max-width="500px">
                <template v-slot:activator="{ on }">
                <p><v-btn color="grey darken-1" class="small" v-on="on" icon block rounded title="Add Similar Contacts">Add Similar Contacts<v-icon>mdi-paperclip</v-icon></v-btn></p>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Similar Contacts</span>
                        <v-spacer></v-spacer>
                        <v-icon @click="closeuins">mdi-close</v-icon>
                    </v-card-title>

                    <div v-if="validationErrors">
                        <ul class="alert alert-danger">
                            <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                        </ul>
                    </div>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                               
                                <v-flex>
  				    <v-file-input accept="text/*" show-size prepend-icon="mdi-paperclip" v-model="file" label="Uploaded files should have one UIN per line and be in a .txt format" hint="Uploaded files should have one UIN per line and be in a .txt format"></v-file-input>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"  @click="closeuins">Cancel</v-btn>
                        <v-btn :loading="isUploading" color="blue darken-1"  @click="uploadAttachment">Upload</v-btn>
                    </v-card-actions>
                </v-card>
      </v-dialog>

                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"  @click="closeadd">Cancel</v-btn>
                        <v-btn color="blue darken-1"  @click="store">Save</v-btn>
                    </v-card-actions>
                </v-card>
      </v-dialog>
      </p>

    <div>
	<div><v-btn icon :href="`/appointments/byuin/${uinFromStore}`" onclick="return popup(this.href, 800, 1024);" target="_blank" title="Contacts">Contacts&nbsp;&nbsp;<v-badge v-if="studentDetails.resource_counts.appointments_count > 0" color="error" :content="studentDetails.resource_counts.appointments_count"></v-badge></v-btn></div>
        <div><v-btn icon :href="`#comments`" title="Comments">Comments&nbsp;&nbsp;<v-badge v-if="studentDetails.resource_counts.comments_count > 0" color="error" :content="studentDetails.resource_counts.comments_count"></v-badge></v-btn></div>
	<div><v-btn icon :href="`/notes/byuin/${uinFromStore}`" onclick="return popup(this.href, 800, 1024);" target="_blank" title="Notes">Notes&nbsp;&nbsp;<v-badge v-if="studentDetails.resource_counts.notes_count > 0" color="error" :content="studentDetails.resource_counts.notes_count"></v-badge></v-btn></div>
	<div><v-btn icon title="View Uploaded Files" @click="filesinfo()">Files&nbsp;&nbsp;<v-badge v-if="studentDetails.resource_counts.files_count > 0" color="error" :content="studentDetails.resource_counts.files_count"></v-badge></v-btn></div>
        <v-file-input outlined accept=".pdf, .doc, .docx, .xlsx" label="Add File" v-model="selectFile" show-size></v-file-input>
        <div><v-btn variant="outlined" class="primary" size="x-small" @click="uploadEducationPlan()" :disabled="!selectFile">Upload</v-btn></div>
    </div>

	</div>

	<div style="text-align: center;" class="col-sm-12 col-md-2 p-4" v-else>
	<p><v-btn icon class="mx-0" href="https://www.uis.edu/registration/onlinereg/" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Register Now">Register Now <v-icon>school</v-icon></v-btn></p>
	<p><div><v-btn icon title="View Uploaded Files" @click="filesinfo()">Files <v-badge v-if="studentDetails.resource_counts.files_count > 0" color="error" :content="studentDetails.resource_counts.files_count"></v-badge></v-btn></div></p>
	</div>


<v-dialog v-model="dialog_files" class="w-full md:w-1/2">

<v-card>
    <v-card-title>
        <span class="headline">Uploaded files: </span>
        <v-spacer></v-spacer>
        <v-divider vertical class="mx-4"></v-divider>
        <v-icon @click="close_files">mdi-close</v-icon>
    </v-card-title>
    <v-divider></v-divider>
     <v-card-text>

  <v-simple-table light fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
           File
          </th>
          <th class="text-left">
           Semester
          </th>
          <th class="text-left">
           Date
          </th>
                    <th class="text-left">

          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in Files">
          <td><v-btn color="primary" small :href="'/files/download-attachment/' + item.file_id">{{ item.file_name }}</v-btn></td>
          <td>{{ item.term_cd }}</td>
          <td>{{ item.created_at }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

                    </v-card-text>
                </v-card>

</v-dialog>

    </div>

    </div>
</div>
</div>
</template>



<style>

@media only screen and (max-width: 768px){
    .row{
      display:flex !important;
      flex-flow:column wrap !important;
    }
  }


</style>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dialog_files: false,
      menu1: false,
      file: null,
      academic_standings: ["Suspension", "Dean's Suspension Override", "Probation - GPA"],
      isUploading: false,
      rawHtml: '<a href="https://www.uis.edu/casa/testing-services" onclick="return popup(this.href, 1024, 724);" target="_blank" title="Placement Test Info">Placement test needed</a>',
      uins: [],
      Files: [],
      selectFile: null,
      dialogadd: false,
      dialoguins: false,
      validationErrors: '',
formdata: new FormData(),
addedItem: {
                start: new Date().toISOString().substr(0, 10),
                request_kind: '',
                format: '',
                advisingdetails: '',
                studentname: '',
		studentuin: '',
		time_spent: '',
            },
defaultItem: {
                start: new Date().toISOString().substr(0, 10),
                request_kind: '',
                format: '',
                advisingdetails: '',
                studentname: '',
		studentuin: '',
		time_spent: '',
            },
request_types: [
        { value: "office", option: "In Person" },
        { value: "email", option: "Email" },
        { value: "zoom", option: "Zoom" },
        { value: "phone", option: "Phone" },
        { value: "record", option: "Record" },
      ],
    };
  },
  computed: {
    ...mapState({
        isAdmin: state => state.student.isAdvisor,
        studentDetailsFromStore: state => state.student.details,
        uinFromStore: state => state.student.currentStudentUin,
	termFromStore: state => state.term.selected,
    }),
    student_full_name() {
	return `${this.studentDetails.firstname} ${this.studentDetails.lastname}`;
    },
    is_licensure_issue() {
	var licensure_program_codes = ["40PG5881BAU","40PG6937BA","40PE0071BA","40PG0095BA","40PG6035BA","40PH1450BS","40PH6085BS","40PG0365BSW","40PE0071MA","40PG9725MA","40PG5555MA","40PG5556MA","40PG5554MA","40PG5412MAU","40PH5185MATR"] ;
	var prog1 = (typeof this.studentDetails.studentRecord.program1 !== "undefined") ? `${this.studentDetails.studentRecord.program1.code}` : '';
	var perm_state = `${this.studentDetails.permanent_state}`;
	var application_term_code = `${this.studentDetails.application_term_code}`
        return (licensure_program_codes.includes(prog1)) && (perm_state != "Illinois") && (application_term_code >= "420248");
    },
    uins_count() {
	return this.uins.length; 
    },
    uin: {
        get(){
          return this.uinFromStore
        },
        set(newName){
          return newName
        } 
    },
    studentDetails: {
        get(){
          return this.studentDetailsFromStore
        },
        set(newName){
          return newName
        } 
    }
  },
  watch: {
      uin: function (val) {
          this.getStudentDetails(val);
      }
  },
  mounted() {
     
  },
  methods: {
 close_files()
	{
	   this.dialog_files = false;
	},
   async filesinfo()
	{
	this.dialog_files = true;
        this.Files = [];
	await axios
        .get("/api/v1/files/" + this.uinFromStore)
        .then((response) => {
          this.Files = response.data;
        })
        .catch((error) => {});
	},
    async getStudentDetails(uin) {
      await axios.get('/api/v1/studentdetailslookup/'+uin)
        .then((response) => {
          this.studentDetails = response.data;
          this.$store.commit("student/setDetails", response.data);
        })
      .catch(error => {});
    },
    closeadd()
    {
           this.validationErrors = ''
            this.dialogadd = false
            setTimeout(() => {
                this.addedItem = Object.assign({}, this.defaultItem)
                this.addedIndex = -1
            }, 300)	 
    },
    onFileChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        
    },
    closeuins()
    {
           this.validationErrors = ''
            this.dialoguins = false
    },
    async store()
    {
	this.addedItem.request_kind = 'app_manual';
	this.addedItem.studentname = this.student_full_name;

	if(this.uins_count == 0)
	{
		this.uins.push(this.uinFromStore);
	}

	this.addedItem.studentuin = this.uins;
	this.addedItem.advisoruin = this.studentDetails.person.uin;
 	await axios.post('/api/v1/appointments', this.addedItem)
                .then(response => {
		this.$store.commit("status/setStatus", {
    		snack: true,
                snackColor: "info",
                snackText: response.data + " - Contact(s) added successfully.",
      });
                    this.closeadd()
                })
                .catch((error) => {
                    // Error

                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (error.response.status == 422) {
                            this.validationErrors = error.response.data.errors;
                        }
			else if (error.response.status == 401) {
		this.$store.commit("status/setStatus", {
    		snack: true,
                snackColor: "error",
                snackText: "Unauthorized - Please close your browser and log in again.",
      });
                            this.validationErrors = "Unauthorized - Please close your browser and log in again.";
                        } 
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js

                    } else {
                        // Something happened in setting up the request that triggered an Error

                    }
                })
    },
    async uploadEducationPlan() {
	    var fileupload  = { "fileupload": this.selectFile , "uin": this.uinFromStore, "term_cd": this.termFromStore };
	//Need Axios v0.27.0 for Automatic serialization to FormData
                await axios.postForm('/api/v1/files', fileupload).then(response => {
                if(response.status === 201) {
			//console.log('data', response.data.StudentFile);
                        this.Files.push(response.data.StudentFile);
			this.selectFile = null;
 	this.$store.commit("status/setStatus", {
                snack: true,
                snackColor: "success",
                snackText: "File uploaded successfully.",
      	});
                }
             else
                    {
 	this.$store.commit("status/setStatus", {
                snack: true,
                snackColor: "error",
                snackText: "File did NOT save.  Please logout and try again.",
      	});
                    }
                    })
         .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
 	this.$store.commit("status/setStatus", {
                snack: true,
                snackColor: "error",
                snackText: "File did NOT save.  Validation error.  See above.",
      	});
                            }
                else if (error.response.status == 401) {
 	this.$store.commit("status/setStatus", {
                snack: true,
                snackColor: "error",
                snackText: "File did NOT save.  Unauthorized - Please close your browser and log in again.",
      	});
                            } 
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
    
                        } else {
                            // Something happened in setting up the request that triggered an Error
    
                        }
                    })
    },

	async uploadAttachment() 
	{
            this.isUploading = true;
            this.formdata.append('attachment', this.file);
            await axios.post('/api/v1/appointments/' + this.uin, this.formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.status === 200) {
    		this.uins = response.data;                
		this.$store.commit("status/setStatus", {
    		snack: true,
                snackColor: "success",
                snackText: (this.uins_count - 1)  + " additional students were added.",
      });
            this.dialoguins = false
                }
            }).catch(error => {
                if(error.response.data.hasOwnProperty('errors'))
                {
                    this.validationErrors = error.response.data.errors.attachment;
                }
            }).finally(() => {
                this.isUploading = false;
            });
        },

    getSports()
    {
	var icon_str = "sports";

	if(this.studentDetails.sports.includes("Baseball"))
	{
		icon_str = "sports_baseball";
	}
	else if(this.studentDetails.sports.includes("Basketball"))
        {
                icon_str = "sports_basketball";
        }

	else if(this.studentDetails.sports.includes("Cross-Country"))
        {
                icon_str = "directions_walk";
        }

	else if(this.studentDetails.sports.includes("Golf"))
        {
                icon_str = "sports_golf";
        }

	else if(this.studentDetails.sports.includes("Soccer"))
        {
                icon_str = "sports_soccer";
        }

	else if(this.studentDetails.sports.includes("Softball"))
        {
                icon_str = "sports_baseball";
        }

	else if(this.studentDetails.sports.includes("Tennis"))
        {
                icon_str = "sports_tennis";
        }

	else if(this.studentDetails.sports.includes("Track"))
        {
                icon_str = "directions_run";
        }

	else if(this.studentDetails.sports.includes("Volleyball"))
        {
                icon_str = "sports_volleyball";
        }

	else
	{
	 icon_str = "sports";
	}

	var result = {
		sport: this.studentDetails.sports,
		icon: icon_str
	}

	return result;
    }
  }
};
</script>
